import * as React from 'react';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import { FormGroup, Label } from 'reactstrap';

function DatePickerSelector({ keyField, formik, label, value, onChange, minDate, maxDate }) {
  const parsedValue = value ? dayjs(value) : null;

  const handleDateChange = (date) => {
    const formattedDate = date ? dayjs(date).format('MM-DD-YYYY') : '';

    if (formik && keyField) {
      formik.setFieldValue(keyField, formattedDate);
    }

    if (onChange) {
      onChange(formattedDate);
    }
  };

  return (
    <FormGroup>
      {label && <Label>{label}</Label>}
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DemoContainer components={['DatePicker']}>
          <DatePicker
            value={parsedValue}
            onChange={handleDateChange}
            minDate={minDate ? dayjs(minDate) : undefined}
            maxDate={maxDate ? dayjs(maxDate) : undefined}
            format="MM-DD-YYYY"
          />
        </DemoContainer>
      </LocalizationProvider>

      {/* Only show formik error if formik exists */}
      {formik?.touched?.[keyField] && formik?.errors?.[keyField] && (
        <div style={{ color: 'red' }}>{formik.errors[keyField]}</div>
      )}
    </FormGroup>
  );
}

export default DatePickerSelector;

